"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _tinymce = _interopRequireDefault(require("tinymce"));

require("tinymce/themes/modern");

var _WindowManagerImpl = _interopRequireDefault(require("./WindowManagerImpl"));

var _NotificationManagerImpl = _interopRequireDefault(require("./NotificationManagerImpl"));

// TODO: as of Tinymce@5 the tinymce.ui namespace does not through the the core library get fleshed out with
// some important pieces for driving intneral UI that we are still reliant on. Specificially the Find and Replace plugin,
// the table properties window, and the the notifications. This workaround should be removed once we have replaced those pieces
// of the UI with our own plugins / theme ui code.
// While we need tinymce.ui (see above) - we need it's internal translation wired
_tinymce.default.ui.Control.translate = _tinymce.default.EditorManager.translate;
var _default = {
  getWindowManagerImpl: function getWindowManagerImpl(editor) {
    return function () {
      return (0, _WindowManagerImpl.default)(editor);
    };
  },
  getNotificationManagerImpl: function getNotificationManagerImpl(editor) {
    return function () {
      return (0, _NotificationManagerImpl.default)(editor);
    };
  }
};
exports.default = _default;
module.exports = exports.default;